import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchGetData = (get: any) => ({
    type: 'FETCH_GET_SUCCESS',
    payload: get,
});
export const fetchData = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchDDetails = (doc: any) => ({
    type: 'FETCH_DOC_SUCCESS',
    payload: doc,
});
export const fetchDDetails1 = (doc1: any) => ({
    type: 'FETCH_DOC1_SUCCESS',
    payload: doc1,
});
export const fetchDDetails2 = (doc2: any) => ({
    type: 'FETCH_DOC2_SUCCESS',
    payload: doc2,
});
export const fetchDDetails3 = (doc3: any) => ({
    type: 'FETCH_DOC3_SUCCESS',
    payload: doc3,
});



export const fetchGet = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:id};
            const apiname = SUPRIVISOR_API.sdoctordata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchGetData(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDatassss = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:2,doctorid:id};
            const apiname = SUPRIVISOR_API.sviewassistantsreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDocData = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,doctorid:id};
            const apiname = SUPRIVISOR_API.sviewassistantsreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDDetails(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDocData1 = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:4,doctorid:id};
            const apiname = SUPRIVISOR_API.sviewassistantsreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDDetails1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDocData2 = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,doctorid:id};
            const apiname = SUPRIVISOR_API.sviewassistantsreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDDetails2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDocData3 = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:6,doctorid:id};
            const apiname = SUPRIVISOR_API.sviewassistantsreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDDetails3(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

